import { CmsObjectWithDefault } from '@components/Cms/types';

export type PhoneSignupFormContainerCmsKey =
    | 'pleaseEnterValidMobileNumber'
    | 'pleaseTryAgain'
    | 'completeCaptcha'
    | 'technicalDifficulty'
    | 'congratulationsYourAccountHasBeenCreated'
    | 'serverError'
    | 'passwordValidationEmpty'
    | 'passwordValidationInvalid'
    | 'phoneAlreadyExist'
    | 'invalidOtpCode';

export const PhoneSignupFormContainerCmsWithDefault: CmsObjectWithDefault<PhoneSignupFormContainerCmsKey> = {
    pleaseEnterValidMobileNumber: {
        cmsId: 85560,
        defaultTranslation: 'Please enter a valid mobile number.',
    },
    pleaseTryAgain: {
        cmsId: 269092,
        defaultTranslation: 'Sorry, we have encountered a technical issue. Please try again.',
    },
    completeCaptcha: {
        cmsId: 67538,
        defaultTranslation: 'Please complete the captcha (above).',
    },
    technicalDifficulty: {
        cmsId: 101793,
        defaultTranslation: 'We are currently experiencing technical difficulties.',
    },
    congratulationsYourAccountHasBeenCreated: {
        cmsId: 76309,
        defaultTranslation: 'Congratulations your account has been created and you have been logged in',
    },
    serverError: {
        cmsId: 82924,
        defaultTranslation: 'Server error',
    },
    passwordValidationInvalid: {
        cmsId: 76577,
        defaultTranslation: 'Please enter a valid password, Must be a minimum 8 Characters',
    },
    passwordValidationEmpty: {
        cmsId: 76304,
        defaultTranslation: 'Your password is empty, please fill in the password',
    },
    phoneAlreadyExist: {
        cmsId: 97926,
        defaultTranslation: 'This phone number’s account already exists, please try to login with your phone.',
    },
    invalidOtpCode: {
        cmsId: 97933,
        defaultTranslation: 'The OTP code is incorrect. Please re-enter or request a new OTP.',
    },
};
